import { approval_rows, authority_fields, delegations_table_rows, doa_tabs, financial_threshold_groups, procurement_authority_groups, risk_routing_rows, sod_conflict_rows, sod_rule_cards, summary_cards } from './delegation_data';
import { delegation_of_authority_computed } from './delegation_computed';
import { exception_requests, drawer_catalog } from './delegation_drawer_data';
import { delegation_of_authority_hooks, delegation_of_authority_methods } from './delegation_helper';
import { control_plane_apps, live_decision_rows, live_decision_stats, route_roles } from './delegation_live_decision_data';
import { modal_catalog } from './delegation_modal_data';

export default {
  name: 'ComplyonDelegationAuthority',
  data: () => ({
    doa_tabs, summary_cards, authority_fields, approval_rows, financial_threshold_groups, procurement_authority_groups, risk_routing_rows, delegations_table_rows, sod_rule_cards, sod_conflict_rows,
    route_roles, control_plane_apps, live_decision_stats, live_decision_rows, exception_requests, modal_catalog, drawer_catalog,
    active_tab: 'overview', active_drawer_key: null, active_modal_key: null, active_modal_data: null
  }),
  computed: { ...delegation_of_authority_computed },
  methods: { ...delegation_of_authority_methods },
  beforeDestroy: delegation_of_authority_hooks.beforeDestroy
};

